<template>
  <svg
    :width="`${svgData.width}px`"
    :height="`${svgData.height}px`"
    :viewBox="svgData.viewBox"
    :aria-labelledby="description"
    :aria-hidden="ariaHidden"
    xmlns="http://www.w3.org/2000/svg"
    :class="['svg', cssClasses]">
    <title :id="description" lang="sv">{{ description }} icon</title>
    <g class="svg__color" :fill="defaultColor" fill-rule="evenodd">
      <component :is="componentName" v-bind="options"></component>
    </g>
  </svg>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    width: {
      type: [Number, String],
      default: undefined
    },
    height: {
      type: [Number, String],
      default: undefined
    },
    color: {
      type: String,
      default: undefined
    },
    svg: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    svgs: {
      arrow: { width: 6, height: 10, viewBox: '0 0 6 10' },
      caret: { width: 16, height: 23, viewBox: '0 0 16 23' },
      cart: { width: 50, height: 40, viewBox: '0 0 50 40' },
      'chat-outline': { width: 15, height: 13, viewBox: '0 0 15 13' },
      chat: { width: 50, height: 43, viewBox: '0 0 50 43' },
      checkmark: { width: 50, height: 50, viewBox: '0 0 50 50' },
      'cheet-edit': { width: 50, height: 50, viewBox: '0 0 50 50' },
      'circle-caret': { width: 30, height: 30, viewBox: '0 0 30 30' },
      'circle-check': { width: 20, height: 20, viewBox: '0 0 20 20' },
      'circle-check-outline': { width: 50, height: 50, viewBox: '0 0 50 50', defaultColor: '#298651' },
      'circle-down': { width: 30, height: 30, viewBox: '0 0 30 30' },
      'circle-information': { width: 32, height: 33, viewBox: '0 0 32 33', defaultColor: '#006DB6' },
      'circle-plus': {
        width: 30,
        height: 30,
        viewBox: '0 0 30 30',
        defaultColor: '#006DB6'
      },
      'circle-warning': { width: 30, height: 30, viewBox: '0 0 30 30' },
      'circle-warning-outline': { width: 50, height: 50, viewBox: '0 0 50 50', defaultColor: '#9d6917' },
      close: {
        width: 60,
        height: 60,
        viewBox: '0 0 60 60',
        defaultColor: '#757272'
      },
      compare: { width: 50, height: 50, viewBox: '0 0 50 50' },
      dk: { width: 90, height: 90, viewBox: '0 0 90 90' },
      'desmiss-circle': { width: 30, height: 30, viewBox: '0 0 30 30' },
      dumper: { width: 111, height: 80, viewBox: '0 0 111 80' },
      embodiment: { width: 50, height: 50, viewBox: '0 0 50 50' },
      eu: { width: 90, height: 90, viewBox: '0 0 90 90' },
      'expand-circle': { width: 30, height: 30, viewBox: '0 0 30 30' },
      facebook: { width: 44, height: 44, viewBox: '0 0 44 44' },
      fastlist: { width: 16, height: 16, viewBox: '0 0 16 16' },
      fi: { width: 90, height: 90, viewBox: '0 0 90 90' },
      '4wd': { width: 72, height: 81, viewBox: '0 0 72 81' },
      global: { width: 50, height: 50, viewBox: '0 0 50 50' },
      gravlastaretraktorgravare: {
        width: 157,
        height: 74,
        viewBox: '0 0 157 74'
      },
      gravmaskin: { width: 155, height: 78, viewBox: '0 0 155 78' },
      grid: { width: 20, height: 20, viewBox: '0 0 20 20' },
      time: { width: 20, height: 20, viewBox: '0 0 20 20' },
      traktor: { width: 100, height: 76, viewBox: '0 0 100 76' },
      trashcan: { width: 13, height: 15, viewBox: '0 0 13 15' },
      troska: { width: 122, height: 74, viewBox: '0 0 122 74' },
      tungaslap: { width: 138, height: 75, viewBox: '0 0 138 75' },
      'header-search': { width: 20, height: 19, viewBox: '0 0 20 19' },
      information: { width: 50, height: 50, viewBox: '0 0 50 50' },
      instagram: { width: 44, height: 44, viewBox: '0 0 44 44' },
      lastmaskin: { width: 125, height: 71, viewBox: '0 0 125 71' },
      linkedin: { width: 44, height: 44, viewBox: '0 0 44 44' },
      list: { width: 20, height: 20, viewBox: '0 0 20 20' },
      'logo-large': { width: 269, height: 69, viewBox: '0 0 269 69' },
      'logo-small': { width: 86, height: 33, viewBox: '0 0 86 33' },
      notify: { width: 16, height: 18, viewBox: '0 0 16 18' },
      notified: { width: 21, height: 24, viewBox: '0 0 21 24' },
      phone: { width: 50, height: 50, viewBox: '0 0 50 50' },
      print: { width: 40, height: 40, viewBox: '0 0 40 40' },
      user: { width: 50, height: 50, viewBox: '0 0 50 50' },
      se: { width: 90, height: 90, viewBox: '0 0 90 90' },
      search: { width: 25, height: 24, viewBox: '0 0 25 24' },
      skogsmaskin: { width: 126, height: 77, viewBox: '0 0 126 77' },
      'star-fill': { width: 12, height: 12, viewBox: '0 0 12 12' },
      'star-outline': { width: 25, height: 25, viewBox: '0 0 510 510' },
      'three-sixty': { width: 54, height: 73, viewBox: '0 0 54 73' },
      mail: { width: 50, height: 37, viewBox: '0 0 50 37' },
      marin: { width: 105, height: 76, viewBox: '0 0 105 76' },
      'new-tab': { width: 18, height: 18, viewBox: '0 0 24 24' },
      volvopenta: { width: 122, height: 75, viewBox: '0 0 122 75' },
      yanmar: { width: 122, height: 75, viewBox: '0 0 122 75' },
      no: { width: 90, height: 90, viewBox: '0 0 90 90' },
      pen: { width: 16, height: 16, viewBox: '0 0 16 16' },
      youtube: { width: 36, height: 44, viewBox: '0 0 36 44' },
      zoom: { width: 31, height: 29, viewBox: '0 0 31 29' },
      'download-invoice': { width: 26, height: 26, viewBox: '0 0 26 26' },
      'delivery-truck': { width: 18, height: 15, viewBox: '0 0 18 15' },
      'order-return': { width: 27, height: 26, viewBox: '0 0 26.297635 25.982096' },
      avatar: { width: 42, height: 42, viewBox: '0 0 22.225 22.225' },
      'avatar-oie': { width: 42, height: 42, viewBox: '0 0 22.225 22.225' },
      gift: { width: 16, height: 16, viewBox: '0 0 16 16' },
      percent: { width: 20, height: 20, viewBox: '0 0 24 28' },
      pause: { width: 80, height: 80, viewBox: '0 0 80 80' },
      'pause-darker': { width: 80, height: 80, viewBox: '0 0 80 80' },
      play: { width: 80, height: 80, viewBox: '0 0 80 80' },
      'play-darker': { width: 80, height: 80, viewBox: '0 0 80 80' },
      'edit-list': { width: 16, height: 16, viewBox: '0 0 16 16' },
      'chevron-down': { width: 14, height: 9, viewBox: '0 0 14 9', defaultColor: 'none' },
      'filter': { width: 16, height: 16, viewBox: '0 0 16 16' },
      'olsson-logo': { width: 793.7, height: 176.3, viewBox: '0 0 793.7 176.3' },
      'circle-error-light': { width: 24, height: 24, viewBox: '0 0 24 24' },
      send: { width: 48, height: 48, viewBox: '0 0 48 48' },
      message: { width: 50, height: 50, viewBox: '0 0 50 50' },
      'close-cross': { width: 50, height: 50, viewBox: '0 0 50 50' },
      minimize: { width: 50, height: 50, viewBox: '0 0 50 50' },
      'bandschaktare': { width: 62, height: 30, viewBox: '0 0 62 30' }
    }
  }),
  computed: {
    ariaHidden() {
      return !this.description
    },
    componentName() {
      return 'Oie' + _.upperFirst(_.camelCase(this.svg))
    },
    currentSvg() {
      return this.svgs[this.svg]
    },
    svgData() {
      return _.merge(
        {},
        this.currentSvg,
        _.pick(this.$props, _.keys(this.currentSvg))
      )
    },
    defaultColor() {
      if (this.svgData.defaultColor && !this.color) {
        return this.svgData.defaultColor
      } else if (this.color === undefined) {
        return 'currentColor'
      } else {
        return this.color
      }
    }
  }
}
</script>

<style lang="scss">
  .svg {
    display: inline-block;
    vertical-align: baseline;
    pointer-events: none;
  }

  .svg--45 {
    transform: rotate(45deg);
  }

  .svg--90 {
    transform: rotate(90deg);
  }

  .svg--90-negative {
    transform: rotate(-90deg);
  }

  .svg--180 {
    transform: scaleX(-1);
  }

  .svg--180-negative {
    transform: rotate(-180deg);
  }

  .svg--270 {
    transform: rotate(270deg);
  }

  .svg--270-negative {
    transform: rotate(-270deg);
  }

  .svg--flip {
    transform: scale(-1);
  }
</style>
